import {Grid} from '@yandex-delivery/blocks'
import {Skeleton} from 'src/shared/components/desktop'

import {BusinessBannerModal} from '../../BusinessBannerModal/BusinessBannerModal'
import {VerticalPlate} from '../VerticalPlate/VerticalPlate'
import * as classes from './DeliveryDirectionVerticals.classes'
import {useDeliveryDirectionVerticals} from './hooks'
import {translations} from './i18n'

const skeleton = (
  <Grid container size="s">
    {Array.from({length: 4}, (_, key) => (
      <Grid item key={`skeleton-${key}`} xs>
        <Skeleton height={12.25} />
      </Grid>
    ))}
  </Grid>
)

export function DeliveryDirectionVerticals() {
  const {verticals, toggleBannerVisibilityHandler, isBannerVisible} =
    useDeliveryDirectionVerticals()

  if (verticals && verticals.length > 0) {
    return (
      <>
        <Grid container wrap="wrap">
          {verticals?.map(vertical => (
            <Grid className={classes.item} item key={vertical.id} xs={4}>
              <VerticalPlate
                disabled={verticals.length === 1}
                name="offerFlow.vertical.name"
                onClick={toggleBannerVisibilityHandler}
                vertical={vertical}
              />
            </Grid>
          ))}
        </Grid>
        <BusinessBannerModal
          description={translations.description}
          imageSrc={translations.imageSrc}
          list={translations.list}
          onClose={toggleBannerVisibilityHandler}
          opened={isBannerVisible}
          title={translations.title}
        />
      </>
    )
  }

  return skeleton
}
